import React, { useEffect } from "react";
import { useState } from "react";
import "./select.scss";
import ClickAwayListener from "../../click-away-listener";

function Select({ children, onChange, placeholder }) {
  const [expanded, setExpanded] = useState(false);
  const [selected, setSelected] = useState({});

  const handleInputClick = () => {
    setExpanded(!expanded);
  };
  const hanldeItemClick = (item) => {
    setSelected(item);
    setExpanded(false);
  };
  let optionsArr = (() => {
    if (Array.isArray(children)) {
      return children.map((item) => {
        return item.props;
      });
    } else if (typeof children === "object") {
      return [children.props];
    } else {
      return [];
    }
  })();

  useEffect(() => {
    if (placeholder) {
      setSelected({ value: "ph", children: placeholder });
    }
    optionsArr.forEach((item) => {
      if (item.selected) {
        setSelected(item);
      }
    });
  }, []);

  useEffect(() => {
    onChange && onChange(selected.value === "ph" ? "" : selected.value);
  }, [selected]);

  return (
    <ClickAwayListener onClickAway={() => setExpanded(false)}>
      <div className="select-root">
        <div
          className={`input-box ${expanded ? "expanded" : ""}`}
          tabIndex={0}
          role="button"
          aria-haspopup="list-box"
          aria-expanded={expanded}
          id="my-custom-select"
          onClick={handleInputClick}
        >
          <span>{selected.children}</span>
          <svg
            className="arrow-down"
            xmlns="http://www.w3.org/2000/svg"
            width="17.18"
            height="9.973"
            viewBox="0 0 17.18 9.973"
          >
            <path
              id="noun-up-4808836"
              d="M192.006,183.628a.573.573,0,0,0,0-.81l-.81-.81a.573.573,0,0,0-.81,0l-6.8,6.8-6.8-6.8a.573.573,0,0,0-.81,0l-.81.81a.573.573,0,0,0,0,.81l8.017,8.017a.572.572,0,0,0,.81,0Z"
              transform="translate(-174.994 -181.841)"
              fill="#d93f04"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <div
          className={`dropdown-box ${expanded ? "expanded" : ""}`}
          tabIndex={-1}
        >
          <ul role="list-box" tabIndex={-1}>
            {placeholder && !selected.children && (
              <li tabIndex={-1} data-value="ph" className="active">
                {placeholder}
              </li>
            )}
            {optionsArr.map(
              (item) =>
                item.value !== selected.value && (
                  <li
                    key={item.value}
                    className={`${item.value === selected ? "active" : ""}`}
                    tabIndex={-1}
                    role="option"
                    aria-selected={true}
                    data-value={item.value}
                    onClick={() => hanldeItemClick(item)}
                  >
                    {item.children}
                  </li>
                )
            )}
          </ul>
        </div>
      </div>
    </ClickAwayListener>
  );
}

export default Select;
